











import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class YesNoPopup extends Vue {
    @Prop() private text: string;
    @Prop() private open: boolean;
    @Prop() private yes: () => void;
    @Prop() private no: () => void;

    // private yes() {
    //     this.onYes();
    // }

    //  private no() {
    //     this.onNo();
    // }
}

Vue.component("mt-yesno-popup", YesNoPopup);
